export default __webpack_public_path__ + "static/media/lining18.dd8d1fe2.jpg";